// extracted by mini-css-extract-plugin
module.exports = {"shopBtn":"R9zk8","blinker":"uFTpN","loader":"gYM2q","affspin":"q6Pjc"};